import React from "react";
import "./tabcontent_admin.css";

const TabContent_admin = ({ id, activeTab, children }) => {
  return activeTab === id ? (
    <div className="TabContent-admin">{children}</div>
  ) : null;
};

export default TabContent_admin;
